import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AutoSub, AutoSubOnDestroy, FeaturedTourService, ProjectService, MoteService } from '../../providers';
import { Mote, MediaFileType, FeaturedTheme, FeaturedTour, AllowedMediaMap, ImageFormat, ImageFormatMap } from '../../models';

@AutoSubOnDestroy()
@Component({
    selector: 'featured-tour-creator',
    templateUrl: './featured-tour-creator.component.html',
    styleUrls: ['./featured-tour-creator.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class FeaturedTourCreatorComponent implements OnInit {

    public activeTour: Mote;
    public featuredTour: FeaturedTour;
    public allowedMediaTypes: AllowedMediaMap = { IMAGE: true };
    public saveResponse: string = '';

    public desktopBannerFormats: ImageFormatMap = {
        'hd': new ImageFormat(MediaFileType.HD, true, 64 / 25, 1920, true),
        'thumb': new ImageFormat(MediaFileType.THUMB, true, 64 / 25, 256, true),
    }

    public desktopTitleFormats: ImageFormatMap = {
        'hd': new ImageFormat(MediaFileType.HD, true, 161 / 45, 644, true),
        'thumb': new ImageFormat(MediaFileType.THUMB, true, 64 / 25, 256, true)
    };

    public mobileBannerFormats: ImageFormatMap = {
        'hd': new ImageFormat(MediaFileType.HD, true, 1 / 1, 600, true),
        'thumb': new ImageFormat(MediaFileType.THUMB, true, 1 / 1, 256, true)
    }

    public mobileTitleFormats: ImageFormatMap = {
        'hd': new ImageFormat(MediaFileType.HD, true, 337 / 68, 600, true),
        'thumb': new ImageFormat(MediaFileType.THUMB, true, 1 / 1, 256, true)
    };

    // Expose to view
    public FeaturedTheme = FeaturedTheme;

    constructor(private projectService: ProjectService,
        private moteService: MoteService,
        private featuredTourService: FeaturedTourService) { }

    ngOnInit(): void {

        // Watch active tour
        AutoSub(this).reg['projectSub'] = this.projectService.watchActiveProject().subscribe(async ev => {
            // Set active tour
            let activeTourKey = ev.project.activeRouteKey;
            this.activeTour = await this.moteService.getMote(activeTourKey);
            // Fetch featured tour or create new
            let featuredTour = await this.featuredTourService.getTourFeature(activeTourKey);
            if(!featuredTour) {
                this.featuredTour = new FeaturedTour();
                this.featuredTour.tourKey = activeTourKey;
            }
            else this.featuredTour = featuredTour;
        })
    }

    public async saveFeaturedTour() {
        await this.featuredTourService.updateFeaturedTour(this.featuredTour);
        this.saveResponse = 'Featured tour saved';
        new Promise<void>((resolve) => setTimeout(() => { resolve() }, 3000));
        setTimeout(() => {
            this.saveResponse = '';
        }, 1500);
    }
}
